import { IShadowStorageFileAttach } from '../interfaces/shadowStorageFileAttach';

export class ShadowStorageFileAttach implements IShadowStorageFileAttach {
    absolutePath: string;
    alternativePath: string;
    contentType: string;
    description: string;
    filename: string;
    id: number;
    idAttachType: number;
    idOwner: number;
    sizeInBytes: number;
    uploadDateTime: Date;
    chiamataPreAdesioneDateTime: Date;

    constructor(sf?: IShadowStorageFileAttach) {
        if (sf) {
            this.absolutePath = sf.absolutePath;
            this.alternativePath = sf.alternativePath;
            this.contentType = sf.contentType;
            this.description = sf.description;
            this.filename = sf.filename;
            this.id = sf.id;
            this.idAttachType = sf.idAttachType;
            this.idOwner = sf.idOwner;
            this.sizeInBytes = sf.sizeInBytes;
            this.uploadDateTime = sf.uploadDateTime;
            this.chiamataPreAdesioneDateTime = sf.chiamataPreAdesioneDateTime != null ? new Date(sf.chiamataPreAdesioneDateTime) : null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/shadowStorageFileAttach.ts